// extracted by mini-css-extract-plugin
module.exports = {"btn_wrap":"copy-campaign-btn_wrap__1ub8z"};